export enum Routes {
  home = "/home",
  login = "/login",
  signup = "/signup",
  linkAccounts = "/link-account",
  consent = "/consent",
  account = "/account",
  consentDetails = "/consent/:type/:consentUniqueId",
  more = "/more",
  termsandconditions = "/terms-and-conditions",
  privacyandpolicy = "/privacy-and-policy",
  grievanceredressal = "/grievance-redressal",
  userprofile = "/user-profile",
  changePassword = "/reset-pin",
  reportIssue = "/report-issue",
  deleteAccount = "/delete-account",
  history = "/history",
}

export enum QueryParams {
  redirect = "redirect",
  entityId = "entityId",
  entityType = "entityType",
  fipId = "fipId",
}

export enum AcitivityTypes {
  account = "Account",
  consent = "Consent",
}
